import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { _ } from '/@/locale';
import useIsMobile from '/@/utils/hooks/is-mobile';
import Title from '/@/v3/components/title';
import Drawing from '../../drawing';

const NoResults = ({ isCropMonitoring }: { isCropMonitoring: boolean }) => {
    const isMobile = useIsMobile();
    const margin = !isMobile && !isCropMonitoring ? '112px' : '0px';
    const CustomizedGrid = styled(Grid)`
        margin-top: ${margin};
        margin-bottom: ${margin};
    `;
    return (
        <CustomizedGrid container spacing={2} direction='column' alignItems='center' justifyContent='center'>
            <Grid item xs={12} md={8} lg={6}>
                <Drawing type='library-not-found' />
            </Grid>
            {!isMobile ? (
                <Grid item xs={12} md={8} lg={6}>
                    <Title size='md' color='light'>
                        {_(
                            'No se han encontrado resultados para esta búsqueda o combinación de filtros. ¡Inténtalo de nuevo!'
                        )}
                    </Title>
                </Grid>
            ) : (
                <>
                    <Grid item xs={12} md={8} lg={6}>
                        <Title size='md' color='light' align='center'>
                            {_('No se han encontrado resultados para esta búsqueda o combinación de filtros.')}
                        </Title>
                    </Grid>
                    <Grid item xs={12} md={8} lg={6}>
                        <Title size='md' color='light' align='center'>
                            {_('¡Inténtalo de nuevo!')}
                        </Title>
                    </Grid>
                </>
            )}
        </CustomizedGrid>
    );
};

export default NoResults;
